import {
  getAllRoles
} from '../../../../api/requests';
import Page from '../../../../components/PageWrapper';
import Button from '../../../../components/form-control/Button';
import {
  getFormattedDate,
  getNameInitials,
  showToast
} from '../../../../utils/miscFunctions';
import { useEffect, useState } from 'react';
import { User } from '../../../../models/User';
import useUserAccount from '../../../../hooks/userAccountHook';
import Loader from '../../../../components/Loader';
import { PlusIcon } from '@heroicons/react/24/outline';
import Avatar from '../../../../components/Avatar';
import { Link, useNavigate } from 'react-router-dom';
import useRoute from '../../../../hooks/routesHook';
import Input from '../../../../components/form-control/Input';

interface RolesAndPermissionsProps {
    isSettings?: boolean;
}

const RolesAndPermissions = ({isSettings= false}: RolesAndPermissionsProps) => {
  const { getProfile } = useUserAccount();
  const { getDashboardBase } = useRoute();
  const [roles, setRoles] = useState<any>([]);
   const [rolesInitialList, setRolesInitialList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchRoleValue, setSearchRoleValue] = useState<string>('')
  const user = new User(getProfile());
  const navigate = useNavigate();
  const sortedOrders = roles && roles?.sort((a:any, b:any) => {
    return a.name.localeCompare(b.name)
  })
  
  useEffect(() => {
    fetchAllRoles();
  }, []);

  const fetchAllRoles = () => {
    setLoading(true);
    getAllRoles()
      .then((response: any) => {
        setRoles(response);
        setRolesInitialList(response)
      })
      .catch((error: any) => {
        showToast.error(error?.description ?? 'Could not load the roles list. Please try again.');
      })
      .then(() => {
        setLoading(false);
      });
  };


  return (
    <Page title="Roles and Permissions">
      <div className="min-h-full bg-white dark:bg-darkBg w-full p-5">
        {loading ? (
          
            <Loader message="Loading roles & permissions. Please wait..." brollyLoaderFixed />
        
        ) : (
          <>
         
          <div className="flex items-center justify-between my-5">
                <Input
            type="search"
            name="search"
            label=""
            value={searchRoleValue}
            // onBlur={handleBlur}
            onChange={(value:any)=>{
              setSearchRoleValue(value.target.value)
              if(value.target.value){
                const roleSearch = roles.filter((role:any) => (String(role.name).toLowerCase().includes(String(value.target.value).toLowerCase())))
             
               setRoles(roleSearch)
              }else{
                setRoles(rolesInitialList)
              }
             
            }}
            placeholder="Search role by name..."
            className='!w-56'
          />
            {user.isOwner() && !isSettings && (
            // {user.isSuperAdmin() && (
              <Button
                label="Create custom role"
                className=" rounded "
                bgColor='primary'
                icon={<PlusIcon className="h-3 w-3 mr-2" />}
                onClick={() => navigate(`${getDashboardBase()}/settings/roles/create-role`)}
              />
            )}
          </div>
            {!roles && <div><h3 className='text-xl font-semibold text-gray-900 dark:text-darkBg-mainText'>No role found</h3></div>}
            <div className="">
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
                {sortedOrders.map((role: any, index: number) => (
                  <div className="p-5 border border-gray-200 dark:border-darkBg-border" key={index}>
                    <span className="text-gray-400 dark:text-darkBg-subText text-xs">
                      Last modified on{' '}
                      {role.updatedOn ? getFormattedDate({ date: role.updatedOn, showTime: true }) : ''}
                    </span>

                    <div className="py-5">
                      <h4 className="font-bold text-gray-900 dark:text-darkBg-mainText">{role.name}</h4>
                      <span className="text-gray-400 dark:text-darkBg-subText text-sm">{role.description}</span>
                    </div>

                    <div className="flex items-center justify-between ">
                      {user.accessRight === role.accessRight ? (
                        <Avatar nameInitials={getNameInitials(user.fullName)} size="xs" />
                      ) : (
                        <div></div>
                      )}
                      <Link
                        className="text-blue-600 dark:text-blue-400 text-xs"
                        to={`/admin/settings/roles/role/${role.id}`}>
                        See permissions
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </Page>
  );
};

export default RolesAndPermissions;
